import React from "react";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import YouTubeIcon from "@mui/icons-material/YouTube";
import BoltIcon from "@mui/icons-material/Bolt";
import CheckIcon from "@mui/icons-material/Check";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import animeImage from "../../img/home/anime-transparent.png";
import { SOCIAL_LINKS } from "../../utils/socialLinks";
import "./HomeSubscribePanel.css";

const features = [
  {
    title: "Instant Delivery",
    text: "Get diamonds in seconds",
    icon: <BoltIcon />,
    tone: "green",
  },
  {
    title: "100% Secure",
    text: "Safe transactions",
    icon: <CheckIcon />,
    tone: "blue",
  },
  {
    title: "Best Prices",
    text: "Guaranteed lowest",
    icon: <LocalOfferIcon />,
    tone: "orange",
  },
  {
    title: "24/7 Support",
    text: "Always here to help",
    icon: <SupportAgentIcon />,
    tone: "purple",
  },
];

const socials = [
  {
    label: "Instagram",
    href: SOCIAL_LINKS.instagram,
    icon: <InstagramIcon />,
  },
  {
    label: "Facebook",
    href: SOCIAL_LINKS.facebook,
    icon: <FacebookIcon />,
  },
  {
    label: "WhatsApp",
    href: SOCIAL_LINKS.whatsappGroup,
    icon: <WhatsAppIcon />,
  },
  {
    label: "YouTube",
    href: SOCIAL_LINKS.youtube,
    icon: <YouTubeIcon />,
  },
];

const HomeSubscribePanel = () => {
  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <section className="homeSubscribe" aria-label="Subscribe and store benefits">
      <div className="homeSubscribeInner">
        <div className="homeSubscribeHero">
          <div className="homeSubscribeAura" />
          <div className="homeSubscribeSlash one" />
          <div className="homeSubscribeSlash two" />

          <div className="homeSubscribeOverlay" />

          <div className="homeSubscribeCharacterFrame">
            <img
              className="homeSubscribeCharacter"
              src={animeImage}
              alt="Anime character pointing"
              loading="lazy"
            />
          </div>

          <div className="homeSubscribeContent">
            <div>
              <h2>SUBSCRIBE</h2>
              <p>Get The Best Deals Now!</p>
            </div>

            <div className="homeSubscribeSocials">
              {socials.map((item) => (
                item.href ? (
                  <a
                    key={item.label}
                    href={item.href}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={item.label}
                    title={item.label}
                  >
                    {item.icon}
                  </a>
                ) : (
                  <span
                    key={item.label}
                    className="homeSubscribeSocialDisabled"
                    aria-disabled="true"
                    aria-label={`${item.label} unavailable`}
                    title={`${item.label} link not set`}
                  >
                    {item.icon}
                  </span>
                )
              ))}
            </div>
          </div>
        </div>

        <div className="homeFeatureGrid">
          {features.map((feature) => (
            <article className="homeFeatureCard" key={feature.title}>
              <span className={`homeFeatureIcon ${feature.tone}`}>
                {feature.icon}
              </span>
              <span>
                <strong>{feature.title}</strong>
                <small>{feature.text}</small>
              </span>
            </article>
          ))}
        </div>

        <div className="homeFloatingActions">
          <button
            className="homeFloatBtn up"
            type="button"
            onClick={scrollTop}
            aria-label="Back to top"
          >
            <KeyboardArrowUpIcon />
          </button>

          <a
            className="homeFloatBtn whatsapp"
            href={SOCIAL_LINKS.whatsappSupport}
            target="_blank"
            rel="noreferrer"
            aria-label="Open WhatsApp"
          >
            <WhatsAppIcon />
          </a>
        </div>
      </div>
    </section>
  );
};

export default HomeSubscribePanel;
